/* HAIB motion layer: scroll reveal, staggered product cards, progress bar, header shrink. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  /* Progress bar + header shrink (cheap, passive, rAF-throttled) */
  if (!reduce) {
    var bar = document.createElement('div');
    bar.className = 'haib-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var ticking = false;
    var update = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
      if (window.scrollY > 40) h.setAttribute('data-haib-scrolled', '');
      else h.removeAttribute('data-haib-scrolled');
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; raf(update); }
    }, { passive: true });
    update();
  }

  /* Reveal on scroll */
  if (reduce || designMode || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    // Cards that appear together animate one after another (left to right, top to bottom)
    var shown = entries.filter(function (e) { return e.isIntersecting; });
    shown.sort(function (a, b) {
      var ra = a.boundingClientRect, rb = b.boundingClientRect;
      return Math.abs(ra.top - rb.top) > 20 ? ra.top - rb.top : ra.left - rb.left;
    });
    shown.forEach(function (e, i) {
      var el = e.target;
      el.style.setProperty('--haib-delay', i * 90 + 'ms');
      el.classList.add('is-in');
      io.unobserve(el);
      // Hand control back to the theme's own hover effects once the entrance is done
      setTimeout(function () {
        el.classList.remove('haib-reveal', 'haib-card', 'is-in');
        el.style.removeProperty('--haib-delay');
      }, 1600 + i * 90);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  var CARD = '.product-grid__item, .resource-list__item, .resource-list__slide';
  var seen = new WeakSet();

  function prepare(el, delay) {
    if (seen.has(el)) return;
    seen.add(el);
    // Only animate things that start below the fold, so nothing flashes at load.
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
    if (delay) el.style.setProperty('--haib-delay', delay + 'ms');
    el.classList.add('haib-reveal');
    if (el.matches(CARD)) el.classList.add('haib-card');
    io.observe(el);
  }

  function scan(root) {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var scope = root || main;

    // Product cards: staggered by their position in the row
    var cards = scope.querySelectorAll(CARD);
    cards.forEach(function (card, i) { prepare(card, 0); });

    // Whole sections that contain no cards (skip the first one: the hero has its own entrance)
    main.querySelectorAll(':scope > .shopify-section').forEach(function (sec, i) {
      if (i === 0) return;
      if (sec.querySelector(CARD)) return;
      prepare(sec, 0);
    });
  }

  scan();

  // Collection filtering / pagination re-renders the grid: pick up new cards.
  var main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      raf(function () { pending = false; scan(); });
    }).observe(main, { childList: true, subtree: true });
  }

  /* Scroll-linked scale: hero image eases out (zoom in on load, back to 1 while scrolling away),
     product cards grow as they reach the middle of the screen and shrink a little as they leave. */
  var hero = document.querySelector('#MainContent .hero');
  var introStart = performance.now();
  var scaleTicking = false;

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function updateScale() {
    scaleTicking = false;
    var vh = window.innerHeight;

    if (hero) {
      var hh = hero.offsetHeight || vh;
      var p = clamp(window.scrollY / hh, 0, 1);
      var intro = clamp((performance.now() - introStart) / 1400, 0, 1);
      intro = 1 - Math.pow(1 - intro, 3);
      hero.style.setProperty('--haib-hs', (1 + 0.07 * intro * (1 - p)).toFixed(4));
      if (intro < 1) scaleTicking = true;
    }

    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      if (r.bottom < -vh * 0.2 || r.top > vh * 1.2) continue;
      var d = clamp(Math.abs((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2), 0, 1);
      cards[i].style.setProperty('--haib-s', (1 - 0.09 * d * d).toFixed(4));
    }
    if (scaleTicking) raf(updateScale);
  }

  function requestScale() {
    if (!scaleTicking) { scaleTicking = true; raf(updateScale); }
  }
  window.addEventListener('scroll', requestScale, { passive: true });
  window.addEventListener('resize', requestScale);
  requestScale();
})();
